/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useIntl } from 'react-intl';
import MDEditor from '@uiw/react-md-editor';
import { Divider, Stack } from '@mui/material';
import { ApiConsentState, ApiConsentStateItem } from '@agunity/api-v4';

import AgButton from '../../stories/Components/AgButton';
import CheckBox from '../../stories/Components/AgCheckBox';
import AgTypography from '../../stories/Styles/AgTypography';

import { useModal } from '../../redux/hooks/modal';
import * as S from './styled';

type Content = {
  consent: ApiConsentStateItem;
  isCloseOnly?: boolean;
  handleConfirm: (state: ApiConsentState) => void;
}

const Content = ({ consent, isCloseOnly, handleConfirm }: Content) => {
  const messages = useIntl().formatMessage;
  const { closeModal } = useModal();

  const [isChecked, setIsChecked] = useState(false);

  return (
    <S.Container data-color-mode='light'>
      <S.MDContainer>
        <MDEditor.Markdown source={consent.description || ''} />
      </S.MDContainer>

      {isCloseOnly ? null : (
        <>
          <Stack direction='row' alignItems='center' gap={2} onClick={() => consent.isMandatory && setIsChecked(!isChecked)}>
            {consent.isMandatory && <CheckBox checked={isChecked} />}
            <AgTypography id='action_desc' contentStyle='AP.Paragraph.Small.Regular' >
              {messages({ id: consent.isMandatory ? 'CONSENT_CHECKBOX_DESC' : 'CONSENT_ACTIONS_DESC' })}
            </AgTypography>
          </Stack>
          <Divider sx={{ pt: 3 }} />
        </>
      )}

      <Stack direction='row' justifyContent='flex-end' alignItems='center' gap={2} sx={{ pt: 2 }}>
        {isCloseOnly ? (
          <AgButton label={'CLOSE'} onClick={closeModal} />
        ) : (
          <>
              {consent.isMandatory ? (
                <AgButton label={'CONSENT_ACTIONS_CONTINUE'} disabled={!isChecked} onClick={() => handleConfirm(ApiConsentState.Agreed)} />
              ) : (
                <>
                  <AgButton variant='outlined' label={'CONSENT_ACTIONS_DISAGREE'} onClick={() => handleConfirm(ApiConsentState.Rejected)} />
                  <AgButton label={'CONSENT_ACTIONS_AGREE'} onClick={() => handleConfirm(ApiConsentState.Agreed)} />
                </>
              )}
          </>
        )}
      </Stack>
    </S.Container>
  );
};

export default Content;